export const formLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
}

// 图幅选项
export const ISO216_OPTIONS = [
    { label: 'A4', value: 'A4' },
    { label: 'A0', value: 'A0' },
    { label: 'A1', value: 'A1' },
    { label: 'A2', value: 'A2' },
    { label: 'A3', value: 'A3' },
    { label: 'A5', value: 'A5' },
    { label: 'A6', value: 'A6' },
    { label: 'B1', value: 'B1' },
    { label: 'B2', value: 'B2' },
    { label: 'B3', value: 'B3' },
    { label: 'B4', value: 'B4' },
    { label: 'B5', value: 'B5' },
    { label: 'B6', value: 'B6' },
]